<template lang="pug">
    .page.allDay
        .head.container
            calendar-title.black
        .stickyHead.container(ref="stickyHead")
            .top
                slider-list(v-if="sliderDates"
                    :slides="sliderDates"
                    :activeSlide="activeSlide"
                    @slideChange="changeDate")
                app-header.black
            events-filters(v-model="filters")
            .app_btn.white_fill(@click="$store.commit('openPopup', 'Subscribe'), $store.commit('setPopupContent', {type: 'day', code: currentDay.CODE, name: currentDay.NAME})") {{$t('other.subscribeDay')}}

        .content(ref="content")
            transition(name="fade")
                .container(v-if="loaded" key="1")
                    events-grid(v-if="events.length")
                        router-link(tag="a" :to="'/'+event.DAY_CODE+'/'+event.CODE" v-for="(event, ind) in events" :key="ind")
                            event-card(:event="event")
                    .message(v-else) {{$t('other.noEvents')}}

                    .app_btn.subscribe.white_fill(@click="$store.commit('openPopup', 'Subscribe'), $store.commit('setPopupContent', {type: 'day', code: currentDay.CODE, name: currentDay.NAME})") {{$t('other.subscribeDay')}}
                    .app_title {{$t('other.newCalendarEvents')}}
                    events-grid(v-if="new_events.length")
                        router-link(tag="a" :to="'/'+event.DAY_CODE+'/'+event.CODE" v-for="(event, ind) in new_events" :key="ind")
                            event-card(:event="event")
                    .app_title {{$t('other.mayInteresting')}}
                    events-grid(v-if="popular_events.length")
                        router-link(tag="a" :to="'/'+event.DAY_CODE+'/'+event.CODE" v-for="(event, ind) in popular_events" :key="ind")
                            event-card(:event="event")
                    .app_btn.white_fill(v-anchor="'.allDay'") {{$t('other.up')}}
                preloader(v-else key="2")
        parallax-figures_event.forDesktop
        parallax-figures_home.forMobile_or_p
</template>

<script>
    import CalendarTitle from "../components/other/CalendarTitle";
    import MonthsList from "../components/elements/MonthsList";
    import SliderList from "../components/elements/SliderList";
    import EventsFilters from "../components/elements/EventsFilters";
    import EventsGrid from "../components/elements/EventsGrid";
    import EventCard from "../components/elements/EventCard";
    import ParallaxFigures_event from "../components/other/ParallaxFigures_event";
    import ParallaxFigures_home from "../components/other/ParallaxFigures_home";
    import Header from "../components/app/Header";
    import Preloader from "../components/other/Preloader";

    import initStickyForIE from "../mixins/initStickyForIE";
    export default {
        name: "AllDay",
        mixins: [initStickyForIE],
        data: ()=>({
            currentDay: null,
            events: [],
            filters: [],
            loaded: false,
        }),
        computed:{
            calendar(){
                return this.$store.state.calendar;
            },
            new_events(){
                return this.$store.state.new_events;
            },
            popular_events(){
                return this.$store.state.popular_events;
            },
            datesWithEvents(){
                let dates = [];
                this.calendar.forEach(m=>{
                    dates = [...dates, ...m.DAYS];
                });
                return dates.filter(d=>d.EVENTS.length);
            },
            sliderDates(){
              return this.datesWithEvents.map(d=>({name: d.NAME, id: d.CODE}))
            },
            activeSlide(){
                return this.sliderDates.findIndex(d=>d.id === this.currentDay.CODE)
            },
        },
        methods:{
            changeDate(id){
                window.scrollTo({
                    top: this.$refs.content.getBoundingClientRect().top + window.pageYOffset - this.$refs.stickyHead.offsetHeight,
                    behavior: 'smooth'
                });
                this.loaded = false;
                setTimeout(()=>{
                    if (this.$route.params.date !== id){
                        this.$router.replace('/'+id);
                    }
                },300)
            },
            setCurrentDay(){
                let day = this.datesWithEvents.find(d=>d.CODE === this.$route.params.date)
                if(day){
                    this.currentDay = day;
                    this.events = this.filters.length ? day.EVENTS.filter(e=>this.filters.includes(e.EVENT_TAG)) : day.EVENTS;
                    setTimeout(()=>{
                        this.loaded = true;
                    }, 100);
                }else{
                    this.$router.replace('/')
                    console.log(404);
                }
            }
        },
        watch:{
            $route(){
                this.setCurrentDay();
            },
            filters(){
                window.scrollTo({
                    top: this.$refs.content.getBoundingClientRect().top + window.pageYOffset - this.$refs.stickyHead.offsetHeight,
                    behavior: 'smooth'
                });
                this.loaded = false;
                setTimeout(()=>{
                    this.setCurrentDay();
                },300)
            }
        },
        created(){
            this.setCurrentDay();
        },
        mounted() {
            this.initStickyForIE(document.querySelector('.stickyHead'));
        },
        components: {
            Preloader,
            appHeader: Header,
            ParallaxFigures_home,
            ParallaxFigures_event, EventCard, EventsGrid, EventsFilters, SliderList, MonthsList, CalendarTitle},
    }
</script>

<style scoped lang="scss">
    .allDay {
        position: relative;
        padding-bottom: 5rem;
        background: #fff;
        color: #000;
    }
    .head {
        position: relative;
        z-index: 3;
        max-width: 115rem;
        margin-bottom: -7.3rem;
        pointer-events: none;
        .calendarTitle::v-deep > *{
            pointer-events: all;
        }
    }
    .stickyHead{
        position: sticky;
        z-index: 2;
        top: -1px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 0 2rem;
        background: #fff;
        .top{
            padding: 3.7vh 0 5vh;
        }
        header{
            display: none;
        }
        .app_btn{
            position: absolute;
            bottom: 1.5rem;
            right: 9em;
            transform: translateY(-50%);
            @include razr1600 {
                right: 5vw;
            }
            @include razr1240 {
                right: 2vw;
            }
            @include mobile_or_P{
                position: static;
                margin-top: 1rem;
            }
        }
    }
    .content{
        position: relative;
        min-height: 100vh;
        z-index: 1;
        .container{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .preloader{
            position: absolute;
            top: 2rem;
            left: 50%;
            transform: translateX(-50%);
        }
        .message{
            text-align: center;
            margin: 7rem 0 12rem;
            font-size: 1.75rem;
        }
    }
    .eventsGrid{
        margin-bottom: 3.25rem;
    }
    .subscribe{
        align-self: flex-end;
        margin: -2.75rem 0.5rem 0.6rem 0;
    }
    @include razr1024{
        .stickyHead .top{
            padding: 1rem;
        }
    }
    @include razr480{
        .stickyHead .top{
            padding: 1.5rem 1rem;
        }
    }
    @include razr320{
        .stickyHead .top{
            padding: 2rem 1rem;
        }
    }
    @include mobile_or_P{
        .head{
            margin-bottom: -2.2rem;
        }
        .parallaxFigures{
            z-index: 3;
        }
        .subscribe{
            align-self: center;
            margin: -2.75rem 0.5rem 2.6rem 0;
        }
        .stickyHead{
            padding: 0 0 0.5rem;
            .top{
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
            }
            &.isSticky{
                .top{
                    justify-content: space-between;
                }
                header{
                    position: absolute;
                    top: 0;
                    right: 0;
                    display: block;
                }
                .sliderList{
                    margin-left: 1rem;
                }
            }
        }
    }
</style>
